import React from "react";
import ReportsDetails from "./ReportsDetails";

const LabReport = () => {
  return <ReportsDetails />;
};

export default LabReport;
